import { css } from '@emotion/react'
import { Flow, FormControl } from 'bold-ui'
import { ErrorField, RadioField } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

import { MamografiaPerguntaField } from '../model-mamografia'

export function MamografiaRastreamentoRadioGroupField() {
  const styles = createStyles()

  return (
    <FormControl label='Mamografia de rastreamento' required>
      <Flow direction='vertical' style={styles.verticalFlow} gap={0.5}>
        <Flow direction='horizontal'>
          <RadioField
            name={MamografiaPerguntaField.mamografiaRastreamento}
            value={RastreioCancerPerguntaOpcaoEnum.POPULACAO_ALVO}
            label='População-alvo'
          />
          <RadioField
            name={MamografiaPerguntaField.mamografiaRastreamento}
            value={RastreioCancerPerguntaOpcaoEnum.POPULACAO_RISCO_ELEVADO_HISTORIA_FAMILIAR}
            label='População de risco elevado (história familiar)'
          />
        </Flow>
        <RadioField
          name={MamografiaPerguntaField.mamografiaRastreamento}
          value={RastreioCancerPerguntaOpcaoEnum.PACIENTE_JA_TRATADO_CANCER_MAMA}
          label='Paciente já tratado de câncer de mama'
        />
      </Flow>
      <ErrorField name={MamografiaPerguntaField.mamografiaRastreamento} />
    </FormControl>
  )
}

const createStyles = () => ({
  verticalFlow: css`
    margin-left: -0.25rem;
    padding-top: 0.3rem;
  `,
})
